<template>
  <div class="calendar-container">
    <div class="paper-hd">
      <h3>竞赛日程</h3>
    </div>
    <!-- 日历组件 -->
    <el-calendar v-model="currentDate">
      <!-- 自定义日期内容 -->
      <template #dateCell="{ date, data }">
        <div class="date-cell">
          <span class="date">{{ formatShowDate(data.day) }}</span>
          <!-- 显示当天比赛：动态绑定tag的type -->
          <div
              v-for="item in getScheduleByDate(data.day)"
              :key="item.id"
              class="schedule-item"
          >

            <el-tooltip
                placement="top"
                effect="dark"
                :content="`${item.competitionName}`"
                :disabled="item.competitionName.length <= 8"
            >
            <el-tag
                :type="item.typeColor || 'primary'"
                size="mini"
                effect="dark"
                class="schedule-tag"
            >
            {{ item.competitionName }}
            </el-tag>
            </el-tooltip>

          </div>
          <!-- 新增按钮 -->
          <!--          <el-button-->
          <!--              size="mini"-->
          <!--              type="text"-->
          <!--              icon="el-icon-plus"-->
          <!--              @click="handleAdd(data.day)"-->
          <!--              v-if="!getScheduleByDate(data.day).length"-->
          <!--              class="add-btn"-->
          <!--          >-->
          <!--            新增-->
          <!--          </el-button>-->
        </div>
      </template>
    </el-calendar>

    <!-- 新增/编辑弹窗：补充type字段的选择 -->
    <el-dialog
        :title="form.id ? '编辑比赛日程' : '新增比赛日程'"
        v-model="dialogVisible"
        width="400px"
        :close-on-click-modal="false"
    >
      <el-form
          :model="form"
          :rules="rules"
          ref="formRef"
          label-width="100px"
          label-position="left"
      >
        <el-form-item label="比赛日期" prop="competitionDate">
          <el-date-picker
              v-model="form.competitionDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              disabled
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="比赛名称" prop="competitionName">
          <el-input
              v-model="form.competitionName"
              placeholder="输入比赛名称"
              maxlength="50"
              show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 新增：比赛类型选择（对应tag的type） -->
        <el-form-item label="比赛类型" prop="type">
          <el-select v-model="form.type" placeholder="选择比赛类型（标签颜色）">
            <el-option label="主要" value="primary"></el-option>
            <el-option label="成功" value="success"></el-option>
            <el-option label="警告" value="warning"></el-option>
            <el-option label="危险" value="danger"></el-option>
            <el-option label="信息" value="info"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="比赛描述">
          <el-input
              v-model="form.competitionDesc"
              type="textarea"
              placeholder="输入比赛描述"
              maxlength="200"
              show-word-limit
              :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCompetitionSchedule } from '@/api/index.js'

export default {
  name: 'CompetitionCalendar',
  data() {
    return {
      currentDate: new Date(), // 当前日历日期
      scheduleList: [], // 所有比赛日程
      dialogVisible: false, // 弹窗显示状态
      form: { // 表单数据：补充type字段
        id: null,
        competitionDate: '',
        competitionName: '',
        type: 'primary', // 默认类型
        competitionDesc: ''
      },
      rules: { // 表单校验
        competitionName: [
          {required: true, message: '请输入比赛名称', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'}
        ],
        type: [ // 可选：添加type字段校验
          {required: true, message: '请选择比赛类型', trigger: 'change'}
        ]
      }
    }
  },
  created() {
    this.fetchSchedule() // 初始化加载数据
  },
  methods: {
    // 格式化显示日期（仅显示日）
    formatShowDate(dateStr) {
      return dateStr.split('-')[2]
    },
    // 按日期筛选比赛
    getScheduleByDate(date) {
      return this.scheduleList.filter(item => item.competitionDate === date)
    },
    // 请求所有比赛数据（实际可优化为按月份请求）
    async fetchSchedule() {
      try {
        const res = await getCompetitionSchedule({
          params: {date: this.formatDate(this.currentDate)}
        })
        if (res.code === "0000") {
          this.scheduleList = res.data || []
        }
      } catch (error) {
        this.$message.error('获取比赛日程失败，请稍后重试')
        console.error('获取日程失败：', error)
      }
    },
    // 格式化日期为yyyy-MM-dd
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toISOString().split('T')[0]
    },
    // 新增比赛
    handleAdd(date) {
      // 重置表单
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.resetFields()
        }
      })
      this.form = {
        id: null,
        competitionDate: date,
        competitionName: '',
        type: 'primary', // 默认类型
        competitionDesc: ''
      }
      this.dialogVisible = true
    },
    // 编辑比赛
    handleEdit(item) {
      // 重置表单校验状态
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
      // 确保type字段有默认值
      this.form = {...item, type: item.type || 'primary'}
      this.dialogVisible = true
    },
    // 删除比赛
    async handleDelete(id) {
      try {
        await this.$confirm(
            '此操作将永久删除该比赛, 是否继续?',
            '提示',
            {
              type: 'warning',
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }
        )
        await axios.delete(`/api/schedule/${id}`)
        this.$message.success('删除成功')
        this.fetchSchedule() // 重新加载数据
      } catch (error) {
        if (error !== 'cancel') { // 排除取消操作的错误
          this.$message.error('删除失败，请稍后重试')
          console.error('删除失败：', error)
        }
      }
    },
    // 提交表单（新增/编辑）
    async submitForm() {
      try {
        const valid = await this.$refs.formRef.validate()
        if (!valid) return

        if (this.form.id) {
          // 编辑
          await axios.put('/api/schedule', this.form)
          this.$message.success('编辑成功')
        } else {
          // 新增
          await axios.post('/api/schedule', this.form)
          this.$message.success('新增成功')
        }

        this.dialogVisible = false
        this.fetchSchedule() // 重新加载数据
      } catch (error) {
        this.$message.error('操作失败，请稍后重试')
        console.error('提交失败：', error)
      }
    }
  },
  watch: {
    // 日历切换月份时重新加载数据
    currentDate: {
      handler() {
        this.fetchSchedule()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-container {
  padding-top: 30px;
}

.schedule-tag {
  max-width: calc(100%); /* 预留删除图标空间 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer; /* 提示可点击 */
  display: inline-block; /* 宽度限制生效 */
}

/* 删除图标样式优化 */
.tag-close-icon {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  margin-left: 4px;
  cursor: pointer;
}
.tag-close-icon:hover {
  color: #fff;
}

/* 日程项间距优化，避免标签堆叠溢出 */
.schedule-item {
  margin-top: 4px;
  width: 100%; /* 占满单元格宽度 */
  box-sizing: border-box;
}

/* 日历单元格优化：增加内边距，避免内容溢出 */
.date-cell {
  min-height: 100px; /* 增加行高 */
  padding: 2px;
  position: relative;
  box-sizing: border-box;
  overflow: hidden; /* 兜底：防止极端情况溢出 */
}

.paper-hd {
  height: 45px;
  margin-top: 20px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;

  h3 {
    float: left;
    font-size: 20px;
    font-weight: 600;
    color: #303133;
    letter-spacing: 1px;
    position: relative;
    padding-left: 14px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 18px;
      background: #409EFF;
      border-radius: 2px;
    }
  }
}

/* 核心：让星期表头居中 */
:deep(.el-calendar-table th) {
  text-align: center !important;
}

/* 调整日历表格单元格高度 */
:deep(.el-calendar-table td) {
  height: 100px !important;
}

.date {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
  display: inline-block;
}

.schedule-item {
}

.add-btn {
  position: absolute;
  bottom: 5px;
  left: 5px;
  padding: 0;
}
</style>
